/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  DeleteAllDataResponse,
  HTTPValidationError,
  SettingsResponse,
  UpdateSettingsRequest
} from './client.schemas'




/**
 * @summary Read Settings
 */
export const settingsReadSettings = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SettingsResponse>> => {
    
    return axios.default.get(
      `/user/settings`,options
    );
  }


export const getSettingsReadSettingsQueryKey = () => {
    return [`/user/settings`] as const;
    }

    
export const getSettingsReadSettingsQueryOptions = <TData = Awaited<ReturnType<typeof settingsReadSettings>>, TError = AxiosError<void | HTTPValidationError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsReadSettings>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettingsReadSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsReadSettings>>> = ({ signal }) => settingsReadSettings({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsReadSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type SettingsReadSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof settingsReadSettings>>>
export type SettingsReadSettingsQueryError = AxiosError<void | HTTPValidationError>

/**
 * @summary Read Settings
 */
export const useSettingsReadSettings = <TData = Awaited<ReturnType<typeof settingsReadSettings>>, TError = AxiosError<void | HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsReadSettings>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSettingsReadSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update Settings
 */
export const settingsUpdateSettings = (
    updateSettingsRequest: UpdateSettingsRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SettingsResponse>> => {
    
    return axios.default.put(
      `/user/settings`,
      updateSettingsRequest,options
    );
  }



export const getSettingsUpdateSettingsMutationOptions = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsUpdateSettings>>, TError,{data: UpdateSettingsRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof settingsUpdateSettings>>, TError,{data: UpdateSettingsRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof settingsUpdateSettings>>, {data: UpdateSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  settingsUpdateSettings(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SettingsUpdateSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof settingsUpdateSettings>>>
    export type SettingsUpdateSettingsMutationBody = UpdateSettingsRequest
    export type SettingsUpdateSettingsMutationError = AxiosError<void | HTTPValidationError>

    /**
 * @summary Update Settings
 */
export const useSettingsUpdateSettings = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsUpdateSettings>>, TError,{data: UpdateSettingsRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof settingsUpdateSettings>>,
        TError,
        {data: UpdateSettingsRequest},
        TContext
      > => {

      const mutationOptions = getSettingsUpdateSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete All Data
 */
export const settingsDeleteAllData = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteAllDataResponse>> => {
    
    return axios.default.post(
      `/user/delete_all_data`,undefined,options
    );
  }



export const getSettingsDeleteAllDataMutationOptions = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsDeleteAllData>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof settingsDeleteAllData>>, TError,void, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof settingsDeleteAllData>>, void> = () => {
          

          return  settingsDeleteAllData(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SettingsDeleteAllDataMutationResult = NonNullable<Awaited<ReturnType<typeof settingsDeleteAllData>>>
    
    export type SettingsDeleteAllDataMutationError = AxiosError<void | HTTPValidationError>

    /**
 * @summary Delete All Data
 */
export const useSettingsDeleteAllData = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsDeleteAllData>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof settingsDeleteAllData>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSettingsDeleteAllDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    